import { render, staticRenderFns } from "./SupplierQuatetionList.vue?vue&type=template&id=78a160c2&scoped=true"
import script from "./SupplierQuatetionList.vue?vue&type=script&lang=js"
export * from "./SupplierQuatetionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a160c2",
  null
  
)

export default component.exports